import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

import { Input } from 'semantic-ui-react';
import CommonErrorIcon
  from 'components/common/CommonErrorIcon';

import './InputField.css';

class InputField extends Component {
  static propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
    onBlur: PropTypes.func,
    id: PropTypes.string,
    hoverable: PropTypes.bool,
    error: PropTypes.object,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    value: null,
    onClick: null,
    onBlur: null,
    id: null,
    hoverable: false,
    error: null,
    placeholder: null,
    className: '',
    disabled: false,
  };

  state = {
    inputActive: false,
  }

  inputFieldRef = createRef();

  setInputActive = inputActive => this.setState({ inputActive });

  handlePencilEditClick = () => {
    this.setInputActive(true);
    if (this.props.customRef) {
      this.props.customRef.current.focus();
    } else {
      this.inputFieldRef.current.focus();
    }
  };

  handleClickOutside = () => {
    this.setInputActive(false);
  }

  handleBlur = event => {
    this.setInputActive(false);
    if (this.props.onBlur) {
      this.props.onBlur(event);
    } else {
      event.target.blur();
    }
  };

  render() {
    const { inputActive } = this.state;
    const { value, placeholder, onChange, onBlur, onKeyDown, customRef, id, hoverable, error, className, disabled } = this.props;

    return (
      <div
        className={
          `input-field__component
          ${inputActive ? ' focused' : ''}
          ${!disabled && hoverable ? ' hoverable' : ''}
          ${error ? ' error' : ''}
          ${className && ` ${className}`}
          ${disabled && ` disabled`}
          `
        }
      >
        <Input
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={this.handleBlur}
          onKeyDown={onKeyDown}
          ref={customRef || this.inputFieldRef}
          onClick={() => { this.setInputActive(true); }}
          disabled={disabled}
          id={id}
        />

        {error &&
          <CommonErrorIcon
            key={`input_${error.id}`}
            errorId={`input_error_${error.id}`}
            errorText={error.text}
          />
        }

        {!inputActive &&
          <div
            className="pencil-icon"
            onClick={this.handlePencilEditClick}
          />
        }
      </div>
    );
  }
}

export default onClickOutside(InputField);
